const pageState = {
    siteKeywordAnalysis: {
        // [project.id]: {
        //     baseLine: {
        //         x: 0,
        //         y: 0
        //     },
        //     filter: [
        //         {
        //             id: 'xxxxxxxx',
        //             name: '絞り込み条件名',
        //             date: '2021-09-01',
        //             value: {
        //                 ctr: [0.1, 100],
        //                 impressions: [0, 1],
        //                 influx: [0, 1],
        //                 keywords: [],
        //                 keywordMatch: 'exactly',
        //                 rank: [1, 100],
        //                 searchVolume: [0, 1],
        //                 urls: [],
        //                 urlMatch: 'prefix',
        //                 directConversion: [0, 1],
        //                 assistedConversion: [0, 1],
        //                 directConversionRate: [0, 100],
        //                 assistedConversionRate: [0, 100]
        //             }
        //         }
        //     ]
        // }
    },
    siteImportantKeyword: {
        checked: ['position', 'clicks', 'ctr', 'conversion']
    },
    siteSummary: {
        organicChecked: ['session', 'impressions', 'clicks', 'ctr', 'rank'],
        organicDevice: 'all',
        summaryChecked: [
            'session',
            'user',
            'visitCount',
            'visitRate',
            'bounceRate',
            'engagementRate'
        ],
        summaryDevice: 'all',
        gaType: {
            // [project.id]: 'ga4' or 'ua'
        }
    },
    tutorial: {
        isNeverOpenModal: false,
        isOpenModal: true
    },
    dashboard: {
        type: 'newContent'
    }
};

const page = {
    namespaced: true,
    state: pageState,
    mutations: {
        setStatus(state, payload) {
            Object.assign(state[payload.page], payload.status);
        },
        reset(state) {
            state.siteKeywordAnalysis = Object.assign(
                {},
                pageState.siteKeywordAnalysis
            );
            state.siteImportantKeyword = Object.assign(
                {},
                pageState.siteImportantKeyword
            );
            state.siteSummary = Object.assign({}, pageState.siteSummary);
            state.tutorial = Object.assign({}, pageState.tutorial);
            state.dashboard = Object.assign({}, pageState.dashboard);
        },
        resetSiteKeywordAnalysis(state, payload) {
            if (state.siteKeywordAnalysis[payload]) {
                delete state.siteKeywordAnalysis[payload];
            }
        }
    },
    actions: {
        setStatus({ commit }, response) {
            commit('setStatus', response);
        },
        reset({ commit }) {
            commit('reset');
        },
        resetSiteKeywordAnalysis({ commit }, response) {
            commit('resetSiteKeywordAnalysis', response);
        }
    }
};

export default page;
